// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import DoraGraphController from "./dora_graph_controller"
application.register("dora-graph", DoraGraphController)

import ExcalidrawController from "./excalidraw_controller"
application.register("excalidraw", ExcalidrawController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SprintPointConclusionChartController from "./sprint_point_conclusion_chart_controller"
application.register("sprint-point-conclusion-chart", SprintPointConclusionChartController)

import SprintPointsGraphController from "./sprint_points_graph_controller"
application.register("sprint-points-graph", SprintPointsGraphController)

import SprintsChartController from "./sprints_chart_controller"
application.register("sprints-chart", SprintsChartController)

import SprintsGoalController from "./sprints_goal_controller"
application.register("sprints-goal", SprintsGoalController)

import ToggleSecretController from "./toggle_secret_controller"
application.register("toggle-secret", ToggleSecretController)

import TeamScheduleController from "./team_schedule_controller"
application.register("team-schedule", TeamScheduleController)
